import { gql } from "@apollo/client";

/**
 * The only read in this feature.
 *
 * Deliberately has no `pollInterval` anywhere it is used: this panel's own
 * calls are metered by the `admin-export` tier at 5/min, 30/hour, 100/day per
 * admin, so an auto-refresh timer locks the admin out of their own dashboard
 * within a minute. Load on mount, refresh on an explicit button, nothing else.
 */
export const RATE_LIMIT_STATUS = gql`
  query RateLimitStatus {
    rateLimitStatus {
      enabled
      redisHealthy
      settings {
        key
        value
        source
      }
    }
  }
`;

/**
 * Step 1 of the unblock flow: what is actually blocking this identifier.
 *
 * Runs on submit and on the explicit refresh button — never on mount, never on
 * a timer. It shares the `admin-export` budget (5/min, 30/hour, 100/day per
 * admin) with every other call on this screen, and an admin working an
 * incident needs those calls for the unblocks themselves.
 *
 * `counters` comes back sorted: blocking first, then closest to the limit.
 * Render it in that order and row one is the answer — see
 * `firstBlockingCounter`.
 */
export const OTP_BLOCK_STATUS = gql`
  query OtpBlockStatus($identifier: String!) {
    otpBlockStatus(identifier: $identifier) {
      identifier
      kind
      blocked
      cascadeWouldBeRefused
      counters {
        tier
        dimension
        value
        window
        used
        limit
        remaining
        resetsInSeconds
        blocking
      }
      correlation {
        destinations
        ipAddresses
        deviceCount
        windowHours
        otpSendRows
      }
    }
  }
`;
